import React from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { selectActors, selectSelectedElement } from "../../../app/slices/TrainingSlice";
import { Actor } from "../../../models/Actor";
import { IConversation } from "../../../models/interactions/Conversation";
import PiPopupWindowPreview from "../components/PiPopupWindowPreview";
import ConversationPreviewBody from "./ConversationPreviewBody";
import { PiAvatarProfileGroup } from "./PiAvatarProfileGroup";

export default function ConversationPreview() {
  //Only use actors present in the conversation preview
  const allActors: Actor[] = useSelector(selectActors);
  const conversationActorIds: string[] = [...new Set(((useSelector(selectSelectedElement) as IConversation).messages).map(message => message.npcId))];
  const conversationActors: Actor[] = allActors.filter(actor => conversationActorIds.includes(actor.id));
  const { t } = useTranslation();

  const title = (
    <div className="flex justify-between w-full">
      <div className="not-italic font-semibold leading-normal text-32 text-interaction-primary ">
        {t("conversation")}
      </div>
      <PiAvatarProfileGroup actors={conversationActors} maxActorsShown={3} />
    </div>);
  const body = <ConversationPreviewBody />;

  return <PiPopupWindowPreview title={title} body={body} hideBottom={true} />;
}